import { render, staticRenderFns } from "./FollowupDetail.vue?vue&type=template&id=eb065268&"
import script from "./FollowupDetail.vue?vue&type=script&lang=js&"
export * from "./FollowupDetail.vue?vue&type=script&lang=js&"
import style0 from "./FollowupDetail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./FollowupDetail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports